// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"6c89e8f9","186":"edfac6e3","331":"c61a3971","339":"efb759e6","362":"57708ee6","375":"d7b6a329","442":"1da9b847","446":"55a95ff6","672":"4c09b3ef","678":"4f03fb5d","778":"9680207d","791":"dfac35ae","805":"8d39ad83"}[chunkId] + ".chunk.js";
};